export enum ErrorCodes {
  EMAIL_IS_ALREADY_USED = 'EMAIL_IS_ALREADY_USED',
  GET_USER_ELIGIBILITY_FAILED = 'GET_USER_ELIGIBILITY_FAILED',
}
